import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {LEVERAGE_1} from "../FxeQuizQuestions";

export const Leverage1 = "tfLeverage1Question";

export function leverage1() {
    return {
        templateUrl: "app/quiz/fxe/questions/Leverage1.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: Leverage1Controller
    };
}

export class Leverage1Controller extends FxeQuizQuestionController {
    public config = LEVERAGE_1;
}
